export const environment = {
  production: false,
  /* bucketName: 'dev-privacy4cars', */

  baseURL: 'https://dev-reports-api.privacy4cars.com',

  authEndpoint: 'https://dev-reports-auth-api.privacy4cars.com/api/auth/v1',

  /* Auth Paths */
  authPublicKeyPath: '/public-key',
  authLoginPath: '/login',
  authResendOTPPath: '/otp/resend',
  authMFAPath: '/login/verify-otp',
  authPWForgot: '/password/forgot',
  authPWReset: '/password/reset',
  authRefreshPath: '/refresh-token',
  authLogoutPath: '/logout',

  filterPrefetchPath: '/api/v1/user-selected-filter',

  /* Landing Page Paths */
  unprocessedSoldCountsPath: "/api/v1/landing-page/unprocessed-sold/counts",
  unprocessedVsProcessedCountsPath: "/api/v1/landing-page/processed-unprocessed/count",

  /* Processed VIN Report Paths */
  processedVinReportTablePath: "/api/v1/processed-vins",
  processedVinReportChartPath: "/api/v1/processed-vins/chart",
  invoiceReportCSVExportPath: "/api/v1/processed-vins/export",

  /* Unprocessed VIN Report Paths */
  unprocessedVinReportTablePath: "/api/v1/unprocessed-vins",
  unprocessedVinReportCSVExportPath: "/api/v1/unprocessed-vins/export",

  /* Unprocessed Sold VIN Report Paths */
  unprocessedVinSoldReportCSVExportPath: "/api/v1/unprocessed-sold-vins/export",
  unprocessedSoldVinReportTablePath: '/api/v1/unprocessed-sold-vins',

  /* VIN Lookup Paths */
  vinLookupPath: '/api/v1/download-certificates/searchByVinCode',
  certificateEmailPath: '/api/v1/download-certificates/download',
  
  /* User Management Paths */
  userManagementPath: '/api/v1/processed-vins/user/dashboard'
}